/**
 * The features the signed-in person can see, each at the stage she sees. Every
 * coach screen that names a feature reads this one cached query. Logic lives in
 * `~/lib/server/features`.
 *
 * Aliases: visible features, features api, coach features query
 */

import { queryOptions } from "@tanstack/react-query";
import { createServerFn } from "@tanstack/react-start";

import { authMiddleware } from "~/lib/auth-middleware";

export const getVisibleFeaturesFn = createServerFn({ method: "GET" })
  .middleware([authMiddleware])
  .handler(async ({ context }) => {
    const { listVisibleFeatures } = await import("~/lib/server/features");
    return listVisibleFeatures(context.user.id, { now: new Date() });
  });

export const visibleFeaturesQueryOptions = queryOptions({
  queryKey: ["features", "visible"] as const,
  queryFn: () => getVisibleFeaturesFn(),
});
